import { matchSegment, splitPath } from "./pathMatching";

/**
 * Checks if a path matches a pattern with dynamic segments (e.g. /foo/[id]).
 * @param path - The actual path (e.g. /foo/123)
 * @param pattern - The pattern path (e.g. /foo/[id])
 * @returns true if the path matches the pattern, false otherwise
 */
export const matchPathWithPattern = (
  path: string,
  pattern: string,
): boolean => {
  const pathSegments = splitPath(path);
  const patternSegments = splitPath(pattern);

  if (pathSegments.length !== patternSegments.length) {
    return false;
  }

  return patternSegments.every((segment, idx) => {
    const result = matchSegment(pathSegments[idx], segment);
    return result.matches;
  });
};
